import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";

const DriversWaterfall = ({ drivers }) => {
  const chartRef = useRef(null);

useEffect(() => {
  if (!drivers) return;

  const chart = echarts.init(chartRef.current);

  const {
    consumptionEffect,
    mixEffect,
    priceEffect,
    deltaCost,
  } = drivers;

  const rawData = [
    { name: "Consumo", value: consumptionEffect },
    { name: "Mix", value: mixEffect },
    { name: "Precio", value: priceEffect },
    { name: "Δ Total", value: deltaCost },
  ];

  // Filtrar valores cero
  const filtered = rawData.filter(
    (d) => Math.abs(d.value) > 0.0001
  );

  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
    },

    xAxis: {
      type: "category",
      data: filtered.map((d) => d.name),
    },

    yAxis: {
      type: "value",
    },

    series: [
      {
        type: "bar",
        data: filtered.map((d) => d.value),
        itemStyle: {
          color: "#4c6ef5",
        },
      },
    ],
  };

  chart.setOption(option);

  return () => {
    chart.dispose();
  };
}, [drivers]);

  return (
    <div
      ref={chartRef}
      style={{ width: "100%", height: 350 }}
    />
  );
};

export default DriversWaterfall;